export const DEFAULT_MAINTENANCE_MESSAGE =
  'Campaign creation is temporarily unavailable while SiteSift completes maintenance.';

export const CLOSED_ADMIN_CAPABILITIES = Object.freeze({
  usageAdmin: false,
  resultsFeature: false,
  tourScheduling: false,
});

export function normalizeAccessState(data) {
  const maintenanceMessage = typeof data?.maintenanceMessage === 'string'
    ? data.maintenanceMessage.trim()
    : '';

  return {
    creationEnabled: data?.creationEnabled === true,
    automationEnabled: data?.automationEnabled === true,
    canStart: data?.canStart === true,
    canAutomate: data?.canAutomate === true,
    capabilities: {
      usageAdmin: data?.capabilities?.usageAdmin === true,
      resultsFeature: data?.capabilities?.resultsFeature === true,
      tourScheduling: data?.capabilities?.tourScheduling === true,
    },
    maintenanceMessage: maintenanceMessage || DEFAULT_MAINTENANCE_MESSAGE,
  };
}
